export default "__VITE_ASSET__hQyvgC$___"